module.exports = __webpack_public_path__ + "static/img/computer.57dc6b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hellohr/computer.png
// module id = LbUO
// module chunks = 0